window.addEventListener("load", () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        const targetValue = parseFloat(el.getAttribute("data-target"));
        const originalText = el.getAttribute("data-display");
        const hasComma = originalText.includes(",");
        const hasDollar = originalText.includes("$");

        if (entry.isIntersecting) {
          let startTimestamp = null;
          const duration = 1000;

          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min(
              (timestamp - startTimestamp) / duration,
              1
            );
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            const currentNum = Math.floor(easeProgress * targetValue);

            let formatted = hasComma
              ? currentNum.toLocaleString("en-US")
              : currentNum.toString();

            el.innerText = (hasDollar ? "$" : "") + formatted;

            if (progress < 1) {
              window.requestAnimationFrame(step);
            } else {
              el.innerText = originalText;
            }
          };
          window.requestAnimationFrame(step);
        } else {
          el.innerText = (hasDollar ? "$" : "") + "0";
        }
      });
    },
    { threshold: 0.1 }
  );

  document
    .querySelectorAll(".count-up")
    .forEach((span) => observer.observe(span));
});
